<template>
  <div class="ibox">
    <div class="ibox-title"><h5>策略管理</h5></div>
    <div class="ibox-content">
    <div class="crud-bar">
      <el-button type="primary" icon="el-icon-plus" @click="openCreate">新建策略</el-button>
    </div>
    <el-table :data="list" v-loading="loading" border stripe>
      <el-table-column prop="id" label="ID" width="70" />
      <el-table-column prop="name" label="名称" />
      <el-table-column prop="identifier" label="标识" />
      <el-table-column prop="desc" label="描述" />
      <el-table-column label="操作" width="160">
        <template slot-scope="s">
          <el-button size="mini" @click="openEdit(s.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="onDelete(s.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="420px">
      <el-form :model="form" label-width="80px">
        <el-form-item label="名称"><el-input v-model="form.name" /></el-form-item>
        <el-form-item label="标识"><el-input v-model="form.identifier" :disabled="!!form.id" /></el-form-item>
        <el-form-item label="描述"><el-input v-model="form.desc" type="textarea" :rows="3" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="onSave">保存</el-button>
      </div>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import { policiesApi } from '../api/admin'

export default {
  name: 'AdminPolicies',
  data () {
    return {
      list: [],
      loading: false,
      dialogVisible: false,
      saving: false,
      editing: null,
      form: { name: '', identifier: '', desc: '' }
    }
  },
  computed: { dialogTitle () { return this.editing ? '编辑策略' : '新建策略' } },
  created () { this.fetch() },
  methods: {
    async fetch () {
      this.loading = true
      try { this.list = await policiesApi.list() } catch (e) { this.$message.error(e.uiMessage || e.message) } finally { this.loading = false }
    },
    openCreate () { this.editing = null; this.form = { name: '', identifier: '', desc: '' }; this.dialogVisible = true },
    openEdit (row) { this.editing = row; this.form = { ...row }; this.dialogVisible = true },
    async onSave () {
      if (!this.form.name) return this.$message.warning('请填写名称')
      this.saving = true
      try {
        if (this.editing) await policiesApi.update(this.editing.id, this.form)
        else await policiesApi.create(this.form)
        this.$message.success('已保存'); this.dialogVisible = false; this.fetch()
      } catch (e) { this.$message.error(e.uiMessage || e.message) } finally { this.saving = false }
    },
    async onDelete (row) {
      if (!await this.$confirm(`确认删除策略「${row.name}」？`, '提示', { type: 'warning' }).catch(() => false)) return
      try { await policiesApi.remove(row.id); this.$message.success('已删除'); this.fetch() } catch (e) { this.$message.error(e.uiMessage || e.message) }
    }
  }
}
</script>

<style scoped>
.crud-bar { margin-bottom: 16px; }
</style>
